import { Col } from "reactstrap";
import { LabelText } from "../Utils/Input";
import SelectField from "../Utils/SelectField";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllPartner } from "../../slices/PartnerMangement/thunk";

export default function FormLine5({
  values,
  touched,
  errors,
  handleBlur,
  setFieldValue,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const partnerData = useSelector((state) => state.Partner.partner);

  useEffect(() => {
    dispatch(fetchAllPartner(setLoading));
  }, [dispatch]);

  const hostOptions = useMemo(() => {
    return (partnerData || []).map((item) => ({
      label: item.tradingName,
      value: item?.id?.split("/").pop(),
    }));
  }, [partnerData]);

  const handleHostChange = (selectedOption) => {
    setFieldValue("hosts", selectedOption ? [selectedOption.value] : []);
  };

  const selectedValue =
    hostOptions.find((opt) => opt.value === values.hosts?.[0]) || null;

  return (
    <Col xxl={3} md={6}>
      <LabelText htmlFor="hosts" displayText="Host" />

      <LabelText
        htmlFor="hosts"
        classLabelName={`d-block ms-0 rv-sub-label ${
          touched.hosts && errors.hosts ? "rv-label-danger" : "rv-label-muted"
        }`}
        displayText={
          touched.hosts && errors.hosts ? errors.hosts : "Choose Host"
        }
      />

      <SelectField
        name="hosts"
        className="basic-select"
        value={selectedValue}
        handleChange={handleHostChange}
        handleBlur={handleBlur}
        options={hostOptions}
        isMulti={false}
        isClearable={true}
        labelName="hosts"
        placeholder={""}
      />
    </Col>
  );
}
